export default function AdminEquipo() {
  return (
    <div>
      <h1 className="text-3xl font-bold text-gradient mb-8">Gestión del Equipo</h1>
      <p className="text-gray-300">Aquí podrás gestionar la información del equipo de trabajo.</p>
    </div>
  )
}
